export const boardFlowChartListTour = {
  key: "boardFlowChartList",
  version: 1,
  getSteps: (t) => [
    {
      target: '[data-tour="board-flowchart-list-back"]',
      content: t("Tour_BoardFlowChartList_Back"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-list-refresh"]',
      content: t("Tour_BoardFlowChartList_Refresh"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-list-tabs"]',
      content: t("Tour_BoardFlowChartList_Tabs"),
      placement: "bottom",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-list-create"]',
      content: t("Tour_BoardFlowChartList_Create"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: '[data-tour="board-flowchart-list-items"]',
      content: t("Tour_BoardFlowChartList_Items"),
      placement: "top",
      disableBeacon: true,
    },
  ],
};
